import React from 'react';
import SvgIcon from '../../../SvgIcon';
import { useIntl, history } from 'umi';
import { getHighLineReg } from '@/pages/home/utils/search';
import {
  getDashboardGamePath,
  getIntelligenceGamePath,
  getOpinionGamePath,
} from '@/pages/home/utils/utils';
import classNames from 'classnames';
import GameImage from '@/pages/home/components/GameImage';
import { Bubble } from 'tea-component';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { IS_GLOBAL } from '@/pages/home/_config/config';
import { OPINIONFEEDSGAMES, ENTITY_TYPE_GP } from '@/pages/home/components/NavHeader/_config';
import { formatReleaseTime, getOpinionGameId } from '../utils';
import { StatusBubbleContent } from '@intelligence/components/DataSourceComponents';

export default function CardItem(props: any) {
  const { data, isAction, getChange, searchText, addSearchHistory } = props;

  const { locale, formatMessage } = useIntl(); // 中英切换方法
  const { resetFilterExtend, resetDetailFilterExtend } = useFilterExtend({});

  // 跳转到其他模块
  const getJumpPath = (item: any): string => {
    const {
      gameId,
      itemObj,
      type: typeData,
      entityType,
      gPopInfo,
      opinionInfo = [],
      consoleId = '',
      pcId = '',
    } = data;
    const type = entityType || typeData;
    const { game_code } = itemObj || {};
    const { project_id } = gPopInfo || {};
    const combineIdList = {
      pc: pcId,
      console: consoleId,
    };
    const opinionGameId = getOpinionGameId(opinionInfo, combineIdList);
    const { titleKey } = item;
    if (titleKey == 'dbh_intelligence') {
      return getIntelligenceGamePath(gameId, type, type === 'company' ? 'Summary' : 'overview');
    }
    if (titleKey == 'dbh_opinion') {
      const opinionGameIdValue = opinionGameId !== '' ? opinionGameId : gameId;
      // 临时方案，针对Gloabl环境下，有以下三款游戏的舆情权限的用户，跳转到舆情Feeds页面
      if (IS_GLOBAL && OPINIONFEEDSGAMES?.includes(opinionGameIdValue)) {
        return getOpinionGamePath(opinionGameIdValue, '', '');
      }
      return getOpinionGamePath(
        opinionGameIdValue,
        type,
        'unified_id',
        '',
        '/opinion/Overview/KeyMetrics',
      );
    }
    if (titleKey == 'dbh_dashboard') {
      // 经分暂时不跳公司，还没做
      if (type === 'company') {
        return '';
      }
      return getDashboardGamePath(game_code);
    }
    if (titleKey === 'dbh_gpop') {
      // GP暂时不跳公司，还没做
      if (type === 'company') {
        return '';
      }
      const filter = { projectId: project_id, tab: 'gameDetail' };
      const filterStr = encodeURIComponent(JSON.stringify(filter || {}));
      return `/g-pop/Pipeline/ProjectList/Detail?filter=${filterStr}`;
    }
    return '';
  };

  const jumpToUrl = (item: any) => {
    const path = getJumpPath(item);
    // 清空情报继承值
    resetFilterExtend?.();
    resetDetailFilterExtend?.();

    const { itemObj = {} } = data;
    const {
      cover,
      entity_name,
      entity_type,
      game_id,
      game_name,
      release_time,
      match_score,
      other_name,
      publisher,
    } = itemObj || {};

    const infoData = {
      game_id,
      game_name,
      entity_name,
      other_name,
      release_time,
      match_score,
      entity_type,
      cover,
      publisher,
    };

    addSearchHistory(searchText, infoData);

    if (path) {
      history.push(path);
    }
  };

  /**
   * 高亮匹配文本
   */
  const highLightMatching = (oText: any, sText: any) => {
    let el = `${oText} `;
    if (sText) {
      // // 全文检索，不区分大小写
      // 第二个参数为函数，是为了返回原文
      el = el.replace(
        getHighLineReg(sText),
        (val) => `<span class="search-high-line">${val}</span>`,
      );
      // 将字符串转换为html
      return <span dangerouslySetInnerHTML={{ __html: el }}></span>;
    }
    return el;
  };

  const clickItemHandle = (e: any, item: any) => {
    if (item?.isDisabled) {
      e.stopPropagation();
    } else if (!item?.isDisabled) {
      jumpToUrl(item);
    }
  };

  return (
    <div
      className={isAction == data.gameId ? 'action-card-item' : 'card-item'}
      onClick={(e) => {
        e.stopPropagation();
        getChange(data.itemObj);
      }}
    >
      <div className="card-item-context">
        <GameImage
          className={classNames(
            'img-object-fit',
            data.imageType == 'mobile' ||
              data.imageType == 'company' ||
              data.imageType == ENTITY_TYPE_GP
              ? 'card-item-img'
              : data.imageType == 'pc'
              ? 'card-item-img1'
              : 'card-item-img2',
          )}
          src={data.img}
          entityType={data.imageType}
        />
        <div className="card-item-message">
          <div className="card-item-titleflex">
            <span className="card-item-title">{highLightMatching(data?.title, searchText)}</span>
            {data?.itemObj?.inactive === true && data?.itemObj?.entity_type === 'mobile' ? (
              <Bubble dark content={<StatusBubbleContent descId="dbi_inactive_hover" />}>
                <span className="dbi-inactive-tag">{formatMessage({ id: 'dbi_inactive' })}</span>
              </Bubble>
            ) : null}
          </div>
          <div className="card-item-flex">
            <SvgIcon type={data.icon} className="card-item-icon" />
            <div className="card-item-titleflex">
              {data.type != 'company' && (
                <span className="card-item-text">
                  {`${formatMessage({ id: 'dbh_metric_release' })} ${formatReleaseTime(locale, {
                    isSpecialReleaseTime: data?.itemObj?.is_special_release_time,
                    releaseTime: data?.itemObj?.release_time,
                    releaseTimeEN: data?.itemObj?.release_time_en,
                    releaseTimeCN: data?.itemObj?.release_time_cn,
                  })}`}
                </span>
              )}
              {data.publisher && <span className="card-item-text">{data.publisher}</span>}
            </div>
          </div>
        </div>
      </div>
      <div className="card-item-right">
        {data?.btnList?.map((item: any, index: any) => (
          <ARightClickToJump href={item?.isDisabled ? '' : getJumpPath(item)} key={index}>
            <Bubble
              trigger="hover"
              style={{ maxWidth: 480 }}
              dark
              content={
                item?.isDisabled ? (
                  <span
                    dangerouslySetInnerHTML={{ __html: formatMessage({ id: item?.tipText }) }}
                  />
                ) : null
              }
            >
              <div
                key={index}
                className={item?.isDisabled ? 'card-item-btndisabled' : 'card-item-btn'}
                onClick={(e) => {
                  clickItemHandle(e, item);
                }}
              >
                <SvgIcon type={item?.icon} className="card-item-btn-icon" />
                {formatMessage({ id: item?.titleKey })}
                <SvgIcon type="point-right" className="card-item-righticon" />
              </div>
            </Bubble>
          </ARightClickToJump>
        ))}
      </div>
    </div>
  );
}
